import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { phoneMask } from '../../utils/masks';

export default function PhoneDisplay({ value, asLink = false, emptyText = '—', sx }) {
  if (!value) return emptyText;
  const formatted = phoneMask(String(value));
  if (asLink) {
    const digitsOnly = String(value).replace(/\D/g, '');
    return (
      <Box component="a" href={`tel:${digitsOnly}`}
           sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, ...sx }}>
        {formatted}
      </Box>
    );
  }
  return <Box component="span" sx={sx}>{formatted}</Box>;
}

PhoneDisplay.propTypes = {
  value: PropTypes.string,
  asLink: PropTypes.bool,
  emptyText: PropTypes.string,
  sx: PropTypes.object,
};
